import {AlertMessageFields} from '../../../../../enums';

export enum AutofillTarget {
    Message = AlertMessageFields.Message,
    Subject = AlertMessageFields.Subject
}

export enum RecipientsType {
    user = 360,
    group = 361,
    email = 362,
    field = 363,
    phone = 364
}
